import type {
  BrandIdentityDetailsResponseSerializer,
  IApiResponse,
  BrandIdentitySubscriptionResponseSerializer,
} from "@litres-libs/types";
import { rtkqApi } from "../api/rtkqApi";

export const brandIdentityApi = rtkqApi.injectEndpoints({
  endpoints: build => ({
    /**
     * Получить конфиг для оператора
     */
    getBrandIdentity: build.query<BrandIdentityDetailsResponseSerializer, void>(
      {
        query: () => ({
          url: `/foundation/api/brand-identity/details`,
        }),
        transformResponse: (
          response: IApiResponse<BrandIdentityDetailsResponseSerializer>
        ) => {
          return response.payload.data;
        },
      }
    ),
    getBrandIdentityByID: build.query<
      BrandIdentityDetailsResponseSerializer,
      { subId: number }
    >({
      query: ({ subId }) => ({
        url: `/foundation/api/brand-identity/subscriptions/${subId}/details`,
      }),
      transformResponse: (
        response: IApiResponse<BrandIdentityDetailsResponseSerializer>
      ) => {
        return response.payload.data;
      },
    }),
    getUserBrandIdentities: build.query<
      BrandIdentitySubscriptionResponseSerializer[],
      void
    >({
      query: () => ({
        url: `/foundation/api/brand-identity/subscriptions`,
      }),
      transformResponse: (
        response: IApiResponse<BrandIdentitySubscriptionResponseSerializer[]>
      ) => {
        return response.payload.data;
      },
    }),
    getBrandIdentityActiveDetails: build.query<
      BrandIdentitySubscriptionResponseSerializer,
      void
    >({
      query: () => ({
        url: `/foundation/api/brand-identity/subscriptions/active/details`,
      }),
      transformResponse: (
        response: IApiResponse<BrandIdentitySubscriptionResponseSerializer>
      ) => {
        return response.payload.data;
      },
    }),
  }),
});
